/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";

export const AnalyticsFilterOperator = {
  Equals: "equals",
  In: "in",
} as const;
export type AnalyticsFilterOperator = ClosedEnum<
  typeof AnalyticsFilterOperator
>;

/** @internal */
export const AnalyticsFilterOperator$outboundSchema: z.ZodMiniEnum<
  typeof AnalyticsFilterOperator
> = z.enum(AnalyticsFilterOperator);
